"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = require("react-redux");
var MovePlayed_1 = require("../Actions/MovePlayed");
function usePlay() {
    var dispatch = (0, react_redux_1.useDispatch)();
    return function (move, options) {
        dispatch(__assign({ type: MovePlayed_1.MOVE_PLAYED, move: move }, options));
    };
}
exports.default = usePlay;
